import { useEffect } from 'react'
import { useLocation } from 'react-router'

import { sendPageView } from '../../utils/analytics'

// Sends a GA4 page_view on every client-side route change. Mount once, inside
// the router. Sensitive query params (?key=... etc.) are redacted inside
// sendPageView, so no secret tokens reach Google.
const GoogleAnalytics = () => {
    const location = useLocation()

    useEffect(() => {
        sendPageView()
    }, [location.pathname, location.search])

    return null
}

export default GoogleAnalytics
